import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { isEmployeeActive } from "./employeeHelpers";

/** Current state only — changing it is an explicit "Activate/Deactivate Employee" action elsewhere. */
function EmployeeStatusTag({ employee }) {
    const { t } = useTranslation("settings");
    const active = isEmployeeActive(employee);

    return (
        <span
            className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ${
                active ? "bg-green-50 text-green-700" : "bg-gray-100 text-gray-600"
            }`}>
            <span className={`h-1.5 w-1.5 rounded-full ${active ? "bg-green-500" : "bg-gray-400"}`} />
            {active ? t("employees.active") : t("employees.inactive")}
        </span>
    );
}

EmployeeStatusTag.propTypes = {
    employee: PropTypes.object,
};

export default EmployeeStatusTag;
